var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useAddPermissions, useRemovePermissions } from '@data/permission/permissionActions';
import { userGroupsApi } from '@data/rest/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
export var userGroupsKeys = Object.freeze({
    all: ['roles'],
    lists: function () {
        return __spreadArray(__spreadArray([], __read(userGroupsKeys.all), false), ['lists'], false);
    },
    list: function () {
        return __spreadArray([], __read(userGroupsKeys.lists()), false);
    },
    details: function () {
        return __spreadArray(__spreadArray([], __read(userGroupsKeys.all), false), ['details'], false);
    },
    detail: function (id) {
        return __spreadArray(__spreadArray([], __read(userGroupsKeys.details()), false), [id], false);
    },
    permissions: function () {
        return __spreadArray(__spreadArray([], __read(userGroupsKeys.lists()), false), ['permissions'], false);
    },
    permission: function (id, filter) {
        return __spreadArray(__spreadArray([], __read(userGroupsKeys.permissions()), false), [id, filter], false);
    },
});
function getUserGroups() {
    return userGroupsApi.list();
}
export function useUserGroups(options) {
    var key = userGroupsKeys.list();
    var rolesQuery = useQuery(key, getUserGroups, options);
    return rolesQuery;
}
export function getAssignedPermissions(context) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, roleId, filter;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 5), roleId = _a[3], filter = _a[4];
            if (!roleId) {
                throw new Error('Role ID was not specified');
            }
            return [2 /*return*/, userGroupsApi.getPermissions(roleId, filter)];
        });
    });
}
export function useGroupAssignedPermissions(roleId, filter, options) {
    var key = userGroupsKeys.permission(roleId, filter);
    return useQuery(key, getAssignedPermissions, __assign(__assign({}, options), { enabled: !!roleId }));
}
function getUserGroup(context) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, id;
        return __generator(this, function (_b) {
            _a = __read(context.queryKey, 3), id = _a[2];
            if (!id) {
                throw new Error('Role ID was not specified');
            }
            return [2 /*return*/, userGroupsApi.get(id)];
        });
    });
}
export function useUserGroup(id, options) {
    var queryClient = useQueryClient();
    var key = userGroupsKeys.detail(id);
    var roleQuery = useQuery(key, getUserGroup, __assign(__assign({}, options), { enabled: !!id, initialData: function () {
            var allRoles = queryClient.getQueryData(userGroupsKeys.list());
            var targetRole = allRoles === null || allRoles === void 0 ? void 0 : allRoles.find(function (r) { return r.id === id; });
            if (targetRole) {
                return __assign({}, targetRole);
            }
        } }));
    return roleQuery;
}
function addRolePermission(command) {
    var id = command.id, permissions = command.permissions;
    return userGroupsApi.addPermissions(id, { permissions: permissions });
}
export function useAddRolePermissions(filter) {
    return useAddPermissions(addRolePermission, userGroupsKeys, filter);
}
function removeRolePermission(command) {
    var id = command.id, permissions = command.permissions;
    return userGroupsApi.removePermissions(id, { permissions: permissions });
}
export function useRemoveRolePermissions(filter) {
    return useRemovePermissions(removeRolePermission, userGroupsKeys, filter);
}
